import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { useLocation } from 'react-router-dom'
import useSetCashinMng from '../hooks/useSetCashinMng'
import useGetMoneyPoolCashin from 'pages/easyPay/payForOther/hooks/useGetMoneyPoolCashin'
import useWalletCashin, {
    walletCashinPayload,
} from 'modules/easyPay/hooks/useWalletCashin'
interface IFooterProps {
    total: number
    commission: number
    ctx_id: number
    ctx_type: string
    destination: string
    gateway: number
    selectedGatewayCode: string | null
    reciever: number
    role: string
    lackOfWallet: number
    isWallet: boolean
    memberId: number
    payment: number
    jsonData: any
    /** Record-mode fund: no gateway exists, so «پرداخت» has nowhere to go. */
    isRecordOnly?: boolean
}
export default function Footer({
    total,
    commission,
    ctx_id,
    ctx_type,
    destination,
    gateway,
    selectedGatewayCode,
    reciever,
    role,
    lackOfWallet,
    isWallet,
    memberId,
    payment,
    jsonData,
    isRecordOnly = false,
}: IFooterProps) {
    // This screen is a deposit into the member's OWN fund, not a payment on
    // someone else's behalf — see the hook's note on `entry`.
    const { mutate } = useGetMoneyPoolCashin(jsonData, 'deposit')
    const { state } = useLocation()

    const { mutate: mutateMng } = useSetCashinMng()
    const { payFromWallet } = useWalletCashin('deposit')
    const [item_type, setItem_type] = useState('psp')
    const [description, setDescription] = useState('')

    useEffect(() => {
        if (state?.formikValue?.type === 'cnc') {
            setItem_type('cst')
            setDescription('افزایش موجودی')
        } else if (state?.formikValue?.type === 'cnhe') {
            setItem_type('hbe')
            setDescription('هبه برای پوشش هزینه')
        } else if (state?.formikValue?.type === 'cnhc') {
            setItem_type('hbc')
            setDescription('هبه بلاعوض')
        } else {
            setItem_type('psp')
            setDescription('پرداخت حق عضویت')
        }
    }, [state?.formikValue?.type])

    return (
        <div className=" w-full">
            <div
                className={
                    isRecordOnly
                        ? ' hidden'
                        : ' mx-8 rounded-xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer'
                }
                onClick={() => {
                    posthog.capture('payment_initiated', { flow_type: 'loan_fund_cashin', amount: total, commission: commission, moneypool_id: (state as any)?.moneyPoolId, gateway: selectedGatewayCode, is_wallet: isWallet })
                    // `lackOfWallet === 0` means the wallet covers the whole
                    // thing, commission included. It used to read
                    // `lackOfWallet && lackOfWallet === 0`, and `0` is falsy —
                    // so this branch never ran once and every "wallet" payment
                    // silently went to the card.
                    const walletCoversAll = isWallet && lackOfWallet === 0
                    if (walletCoversAll) {
                        // No gateway at all: the fund is credited and the
                        // wallet debited by the same POST, the way Android does
                        // it. Deliberately OUTSIDE the gateway check — asking
                        // someone to pick a bank for a payment no bank touches
                        // is friction at best, and a dead end on a fund that
                        // has no gateway to offer.
                        payFromWallet(
                            walletCashinPayload({
                                poolshipId: state?.poolShipId,
                                moneypoolId: Number(state?.moneyPoolId),
                                amount: total,
                                type: state?.formikValue?.type ?? 'cnp',
                                destination: destination,
                                tag: state?.formikValue?.tag ?? '',
                            }) as any
                        )
                    } else if (selectedGatewayCode) {
                        // Either a plain card payment, or the wallet covering
                        // part of it and the card taking the rest. `use_wallet`
                        // is what tells the backend to net the balance off
                        // first (`payment/api/views.py`) — without it the
                        // member is charged the full amount and the wallet
                        // keeps sitting there.
                        mutate({
                            paymentItems: [
                                {
                                    itemAmount: total,
                                    itemType: item_type,
                                    itemId: state?.poolShipId,
                                    box_id: Number(state?.moneyPoolId),
                                    commission: commission,
                                    description: description,
                                },
                            ],
                            gateway: { uniqueCode: selectedGatewayCode },
                            clientType: 'pwa',
                            ...(isWallet ? { use_wallet: true } : {}),
                        })
                    } else {
                        toast.error('نوع درگاه پرداخت را انتخاب کنید')
                    }
                }}
            >
                پرداخت
            </div>
            {(state?.role === 'mgr' || state?.role === 'own') && (
                <div
                    onClick={() => {
                        posthog.capture('payment_record_initiated', { flow_type: 'manager_record', amount: total, moneypool_id: (state as any)?.moneyPoolId })
                        const payload: IFuckingPayload = {
                            moneyPool: state?.moneyPoolId,
                            poolship: state?.poolShipId,
                            amount: total,
                            type: state?.formikValue?.type,
                            // the «توضیحات» the manager typed — Android sends it
                            // (MoneypoolApiCallManager:914) and it shows up in
                            // the fund's transaction list; we used to drop it.
                            tag: state?.formikValue?.tag ?? '',
                        }
                        mutateMng(payload)
                    }}
                    // `isRecordOnly` hides «پرداخت» above, so this is then
                    // the only action on the screen and has to look like it.
                    className={`mx-8 rounded-xl text-center py-3 my-2 cursor-pointer ${
                        isRecordOnly
                            ? 'bg-green-1 text-white'
                            : 'bg-transparent text-green-1 border-1 border-green-1'
                    }`}
                >
                    پرداخت تنها ثبت شود
                </div>
            )}
        </div>
    )
}
